import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-map-layout-change',
  templateUrl: './map-layout-change.component.html',
  styleUrl: './map-layout-change.component.scss',
  standalone: false,
})
export class MapLayoutChangeComponent extends BaseComponent implements OnInit {
  public menuItems: MenuItem[] = [];

  public layouts = [
    { type: 'Breadthfirst', icon: 'graph_1', label: 'Breadthfirst', rotate: 'left' },
    { type: 'Circle', icon: 'graph_6', label: 'Circle' },
    { type: 'Concentric', icon: 'graph_5', label: 'Concentric' },
    { type: 'Dagre', icon: 'graph_2', label: 'Dagre' },
    { type: 'Grid', icon: 'grid_view', label: 'Grid' },
    { type: 'Klay', icon: 'flowchart', label: 'Klay' }, //todo  - need to change
    { type: 'Random', icon: 'graph_7', label: 'Random' },
  ];

  constructor(private toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
  }

  ngOnInit(): void {
    this.initializeMenuItems();
  }

  private initializeMenuItems(): void {
    this.menuItems = this.layouts.map((layout) => ({
      label: layout.label,
      icon: layout.icon,
      rotate: layout.rotate,
      command: () => this.onChangeLayout(layout.type),
    }));
  }

  public onChangeLayout(newLayout: string) {
    this.toolbarEventManagerHelper.MapToolbarLayout = newLayout;
  }
}
